export default function removeEmojis(string) {
	const regex =
		/[\uD800-\uDBFF][\uDC00-\uDFFF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g;
	const stringWithoutEmojis = string.replace(regex, "");

	return stringWithoutEmojis ?? string;
}
